import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state: {
    ficheTableauData: null,
    currentLigne: null,
    currentFiche: null,
    lastFiche: null,
    currentFicheData: null,
    templatesFiche: {},
    isLoadingTemplatesFiche: false,
    isProjectTemplate: false,
    templateId: null,
    isLoadingFiches: false,
    droppedHeaders: [],
    deletedHeaders: [],
    toolbarSelected: false,
    isLoadingFicheData: false,
    isLoadingFicheEspaces: false,
    tableauTemplateId: null,
    selectedFiches: [],
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ficheEspace/index.js